import React, { createContext, useContext, useState, useEffect } from 'react';

const FontContext = createContext();

export const DEFAULT_FONT_NAME = 'Default';
export const DEFAULT_SYSTEM_FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const FONT_OPTIONS = [
  { name: DEFAULT_FONT_NAME, fontFamily: DEFAULT_SYSTEM_FONT_STACK },
  { name: 'PT Serif', fontFamily: "'PT Serif', serif" },
  { name: 'Inter', fontFamily: `Inter, ${DEFAULT_SYSTEM_FONT_STACK}` },
  { name: 'Funnel Display', fontFamily: `"Funnel Display", ${DEFAULT_SYSTEM_FONT_STACK}` },
  { name: 'Sour Gummy', fontFamily: `"Sour Gummy", ${DEFAULT_SYSTEM_FONT_STACK}` },
  { name: 'DynaPuff', fontFamily: `DynaPuff, ${DEFAULT_SYSTEM_FONT_STACK}` },
  { name: 'Yusei Magic', fontFamily: `"Yusei Magic", ${DEFAULT_SYSTEM_FONT_STACK}` },
];

const FONT_FAMILY_BY_NAME = FONT_OPTIONS.reduce((acc, font) => {
  acc[font.name] = font.fontFamily;
  return acc;
}, {});

export const resolveFontFamily = (fontName) =>
  FONT_FAMILY_BY_NAME[fontName] || DEFAULT_SYSTEM_FONT_STACK;

export const FontProvider = ({ children }) => {
  const [currentFont, setCurrentFont] = useState(() => {
    const savedFont = localStorage.getItem('preferred-font');
    return FONT_FAMILY_BY_NAME[savedFont] ? savedFont : DEFAULT_FONT_NAME;
  });

  useEffect(() => {
    // Update localStorage when font changes
    localStorage.setItem('preferred-font', currentFont);
    // Update body font-family
    document.body.style.fontFamily = resolveFontFamily(currentFont);
    document.body.classList.toggle('font-default', currentFont === DEFAULT_FONT_NAME);

    return () => {
      document.body.classList.remove('font-default');
    };
  }, [currentFont]);

  return (
    <FontContext.Provider value={{ currentFont, setCurrentFont }}>
      {children}
    </FontContext.Provider>
  );
};

export const useFont = () => {
  const context = useContext(FontContext);
  if (!context) {
    throw new Error('useFont must be used within a FontProvider');
  }
  return context;
};
